<template>
  <v-dialog
    v-model="dialogLocal"
    max-width="450px"
    persistent
  >
    <v-card>
      <v-card-title class="headline-custom" style="font-size: 1.3rem !important">
        Exportar CSV do Relatório #{{relatorio.id}}
      </v-card-title>
      <v-card-text style="font-size: 15px !important">
        <template v-if="!processandoArquivo">
          <v-row class="align-center justify-center">
            <v-checkbox
              v-model="checkboxExportarFormatoSDI"
              label="Exportar o arquivo no formato SDI"
            />
          </v-row>
          <parametros-arquivo-csv
            v-if="!checkboxExportarFormatoSDI"
            :delimitador.sync="delimitador"
            :involucro.sync="involucro"
            :escape.sync="escape"
          />
          <encoding :encoding.sync="encoding" />
        </template>
        <template v-else>
          <p class="font-weight-light mb-0 text-center">
            Por favor aguarde, seu arquivo está sendo gerado...
          </p>
          <v-progress-linear
            indeterminate
            color="primary"
          />
        </template>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="green darken-1"
          text
          @click="dialogLocal = false"
        >
          Fechar
        </v-btn>
        <v-btn
          v-show="!processandoArquivo"
          color="green darken-1"
          @click="
            $emit('submitTriggered', exportData())
            forcedLoading = true
          "
          :disabled="processandoArquivo"
        >
          Exportar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import pusherMixins from "@/mixins/pusherMixins";

export default {
  mixins: [pusherMixins],
  components: {
    ParametrosArquivoCsv: () => import('@/components/general/GeneralParametrosArquivoCsv'),
    Encoding: () => import('@/components/general/GeneralEncoding')
  },

  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    relatorio: {
      type: Object,
      required: true
    }
  },

  mounted() {
    this.subscribe();
  },

   data: () => ({
    delimitador: ';',
    involucro: '"',
    escape: '"',
    encoding: "UTF-8",
    checkboxExportarFormatoSDI: false,
    forcedLoading: false
  }),

  computed: {
    dialogLocal: {
      get() {
        return this.dialog;
      },
      set(newValue) {
        this.$emit('update:dialog', newValue);
      }
    },
    processandoArquivo() {
      if (this.forcedLoading) return true;

      return ['EXECUTANDO', 'AGUARDANDO'].includes(this.relatorio.status_exportar_csv_como);
    }
  },

  methods: {
    subscribe () {
      this.pusherChannel.bind('refreshActionExportarComo', () => {
        this.$toast.success('CSV customizado gerado com sucesso', "", { position: "topRight" });
        this.dialogLocal = false;
        this.forcedLoading = false;
        this.$emit('processamentoFinalizado', this.relatorio.id);
      })
    },

    exportData() {
      return {
        consulta_id: this.relatorio.id,
        delimitador: this.delimitador,
        involucro: this.involucro,
        escape: this.escape,
        encoding: this.encoding,
        sdi: this.checkboxExportarFormatoSDI
      };
    }
  }
}
</script>